import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Wortmarke_okr_2_weiß.png'


const _withScopeId = n => (_pushScopeId("data-v-4ec83a12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    height: "45"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarNav"
}
const _hoisted_5 = { class: "navbar-nav ms-auto" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item\" data-v-4ec83a12><a class=\"nav-link\" href=\"/#hero\" data-v-4ec83a12>Home</a></li><li class=\"nav-item\" data-v-4ec83a12><a class=\"nav-link\" href=\"#features\" data-v-4ec83a12>Features</a></li><li class=\"nav-item\" data-v-4ec83a12><a class=\"nav-link\" href=\"#pricing\" data-v-4ec83a12>Preise</a></li><li class=\"nav-item\" data-v-4ec83a12><a class=\"nav-link\" href=\"#contact\" data-v-4ec83a12>Kontakt</a></li>", 4)
const _hoisted_10 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: "/login"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Login")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}